import { createAction, props } from '@ngrx/store';

import { GraphFilter, Notification, ReportCurrentMonth, ReportEndValues, ReportItem, TransactionItem } from '@shared/models/Reporting';
import { SuperhumanQuestion } from '@shared/models/Superhuman';

export const fetchEndValues = createAction('[Reporting] Get customer reporting end values');
export const fetchEndValuesSuccess = createAction(
  '[Reporting] Get customer reporting end values success',
  props<{ endValues: ReportEndValues }>()
);

export const fetchTransactions = createAction('[Reporting] Get customer reporting transactions');
export const fetchTransactionsSuccess = createAction(
  '[Reporting] Get customer reporting transactions success',
  props<{ transactions: TransactionItem[] }>()
);

export const getGraphData = createAction('[Reporting] Get graph data');

export const getGraphDataSuccess = createAction('[Reporting] Get graph data success', props<{ data: ReportItem[] }>());

export const getGraphDataUnsuccess = createAction('[Reporting] Get graph data unsuccess', props<{ error: boolean }>());

export const getCurrentMonthSuccess = createAction('[Reporting] Get graph data month success', props<{ data: ReportCurrentMonth }>());

export const changePerformanceFilter = createAction('[Reporting] Change performance filter', props<{ payload: GraphFilter }>());

export const fetchEndValuesStatus = createAction('[Reporting] reporting status', props<{ value: boolean }>());

export const getCustomerNotifications = createAction('[Reporting] Get customer notifications');

export const getCustomerNotificationsSuccess = createAction(
  '[Reporting] Get customer notifications success',
  props<{ data: Notification[] }>()
);

export const updateTransactionsPagination = createAction('[Reporting] Update transactions pagination', props<{ currentPage: number }>());
export const updateSuperhumanExitSurvey = createAction('[Reporting] Update superhuman eit survey', props<{ value: boolean }>());
export const showSuperhumanExitModal = createAction('[Reporting] Show super human exit modal', props<{ show: boolean }>());

export const fetchSuperhumanSurvey = createAction('[Reporting] Fetch superhuman survey');
export const fetchSuperhumanSurveySuccess = createAction(
  '[Reporting] Fetch superhuman survey success',
  props<{ survey: SuperhumanQuestion[] }>()
);
export const fetchSuperhumanSurveyFailed = createAction('[Reporting] Fetch superhuman survey failed', props<{ error: any }>());
export const ignoreSuperhumanSurvey = createAction('[Reporting] Ignore superhuman survey', props<{ notificationId: number }>());
export const ignoreSuperhumanSurveySuccess = createAction('[Reporting] Ignore superhuman survey success');
export const ignoreSuperhumanSurveyFailed = createAction('[Reporting] Ignore superhuman survey failed');
